import React from 'react';

import SEO from '@/components/common/SEO';

import Mission from './mission/Mission';
import Definition from './definition/Definition';
import Team from './team/Team';
import Acknowledgments from './acknowledgments/Acknowledgments';

const About = () => {
    const description =
        "Learn about Sustainability Hub's mission to empower communities with " +
        'data-driven sustainability insights. Meet our interdisciplinary team of ' +
        'researchers from multiple universities working together on sustainable solutions.';

    return (
        <div>
            <SEO
                title="About Us"
                description={description}
                canonical="/about"
                breadcrumbs={[
                    { name: 'Home', path: '/' },
                    { name: 'About', path: '/about' },
                ]}
            />
            <Mission />
            <Definition />
            <Team />
            <Acknowledgments />
        </div>
    );
};
export default About;
